import AlbumFolderPurchasePrePurchase from './AlbumFolderPurchasePrePurchase';

export default AlbumFolderPurchasePrePurchase;
